
export const UPDATE_JOB = 'UPDATE_JOB';

export const GET_JOB_REQUEST = 'GET_JOB_REQUEST';
export const GET_JOB_SUCCESS = 'GET_JOB_SUCCESS';
export const GET_JOB_FAIL = 'GET_JOB_FAIL';

export const GET_ALL_JOBS_REQUEST = 'GET_ALL_JOBS_REQUEST';
export const GET_ALL_JOBS_SUCCESS = 'GET_ALL_JOBS_SUCCESS';
export const GET_ALL_JOBS_FAIL = 'GET_ALL_JOBS_FAIL';

export const GET_ACTIVE_JOBS_REQUEST = 'GET_ACTIVE_JOBS_REQUEST';
export const GET_ACTIVE_JOBS_SUCCESS = 'GET_ACTIVE_JOBS_SUCCESS';
export const GET_ACTIVE_JOBS_FAIL = 'GET_ACTIVE_JOBS_FAIL';

export const GET_JOBS_BY_CATEGORY_REQUEST = 'GET_JOBS_BY_CATEGORY_REQUEST';
export const GET_JOBS_BY_CATEGORY_SUCCESS = 'GET_JOBS_BY_CATEGORY_SUCCESS';
export const GET_JOBS_BY_CATEGORY_FAIL = 'GET_JOBS_BY_CATEGORY_FAIL';

export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_FAIL = 'CREATE_JOB_FAIL';

export const UPDATE_JOB_REQUEST = 'UPDATE_JOB_REQUEST';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const UPDATE_JOB_FAIL = 'UPDATE_JOB_FAIL';

export const DELETE_JOB_REQUEST = 'DELETE_JOB_REQUEST';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAIL = 'DELETE_JOB_FAIL';

export const SET_JOB_LOADING = 'SET_JOB_LOADING';


export const IMPORT_JOBS_EXCEL_REQUEST = "IMPORT_JOBS_EXCEL_REQUEST";
export const IMPORT_JOBS_EXCEL_SUCCESS = "IMPORT_JOBS_EXCEL_SUCCESS";
export const IMPORT_JOBS_EXCEL_FAIL    = "IMPORT_JOBS_EXCEL_FAIL";

export const EXPORT_JOBS_REQUEST = "EXPORT_JOBS_REQUEST";
export const EXPORT_JOBS_SUCCESS = "EXPORT_JOBS_SUCCESS";
export const EXPORT_JOBS_FAIL    = "EXPORT_JOBS_FAIL";

export const DOWNLOAD_JOBS_TEMPLATE_REQUEST = "DOWNLOAD_JOBS_TEMPLATE_REQUEST";
export const DOWNLOAD_JOBS_TEMPLATE_SUCCESS = "DOWNLOAD_JOBS_TEMPLATE_SUCCESS";
export const DOWNLOAD_JOBS_TEMPLATE_FAIL    = "DOWNLOAD_JOBS_TEMPLATE_FAIL";

export const CLEAR_JOBS_IMPORT_RESULT = "CLEAR_JOBS_IMPORT_RESULT";
// ========================================
// 🎬 ACTION CREATORS
// ========================================
export const clearJobsImportResult = () => ({
    type: CLEAR_JOBS_IMPORT_RESULT,
});
export const importJobsExcelRequest = (file, dryRun, action) => ({
    type: IMPORT_JOBS_EXCEL_REQUEST,
    payload: { file, dryRun, action },
});

export const exportJobsRequest = () => ({ type: EXPORT_JOBS_REQUEST });

export const downloadJobsTemplateRequest = () => ({ type: DOWNLOAD_JOBS_TEMPLATE_REQUEST });
export const updateJob = (job) => {
    return {
        type: UPDATE_JOB,
        job
    };
}

// --- Récupérer un poste par ID ---
export const getJobRequest = (jobId) => ({
    type: GET_JOB_REQUEST,
    payload: { jobId }
});

export const getJobSuccess = (job) => ({
    type: GET_JOB_SUCCESS,
    payload: job
});

export const getJobFail = (error) => ({
    type: GET_JOB_FAIL,
    error
});

// --- Récupérer tous les postes ---
export const getAllJobsRequest = () => ({
    type: GET_ALL_JOBS_REQUEST
});

export const getAllJobsSuccess = (jobs) => ({
    type: GET_ALL_JOBS_SUCCESS,
    payload: jobs
});

export const getAllJobsFail = (error) => ({
    type: GET_ALL_JOBS_FAIL,
    error
});

// --- Récupérer les postes actifs ---
export const getActiveJobsRequest = () => ({
    type: GET_ACTIVE_JOBS_REQUEST
});

export const getActiveJobsSuccess = (jobs) => ({
    type: GET_ACTIVE_JOBS_SUCCESS,
    payload: jobs
});

export const getActiveJobsFail = (error) => ({
    type: GET_ACTIVE_JOBS_FAIL,
    error
});

// --- Récupérer postes par catégorie ---
export const getJobsByCategoryRequest = (category) => ({
    type: GET_JOBS_BY_CATEGORY_REQUEST,
    payload: { category }
});

export const getJobsByCategorySuccess = (jobs) => ({
    type: GET_JOBS_BY_CATEGORY_SUCCESS,
    payload: jobs
});

export const getJobsByCategoryFail = (error) => ({
    type: GET_JOBS_BY_CATEGORY_FAIL,
    error
});

// --- Créer un poste ---
export const createJobRequest = (jobData, history) => ({
    type: CREATE_JOB_REQUEST,
    payload: jobData,
    history
});

export const createJobSuccess = (job) => ({
    type: CREATE_JOB_SUCCESS,
    payload: job
});

export const createJobFail = (error) => ({
    type: CREATE_JOB_FAIL,
    error
});

// --- Mettre à jour un poste ---
export const updateJobRequest = (jobId, jobData) => ({
    type: UPDATE_JOB_REQUEST,
    payload: { jobId, jobData }
});

export const updateJobSuccess = (job) => ({
    type: UPDATE_JOB_SUCCESS,
    payload: job
});

export const updateJobFail = (error) => ({
    type: UPDATE_JOB_FAIL,
    error
});

// --- Supprimer un poste ---
export const deleteJobRequest = (jobId, history) => ({
    type: DELETE_JOB_REQUEST,
    payload: { jobId },
    history
});

export const deleteJobSuccess = (jobId) => ({
    type: DELETE_JOB_SUCCESS,
    payload: { jobId }
});

export const deleteJobFail = (error) => ({
    type: DELETE_JOB_FAIL,
    error
});

// --- Loading ---
export const setJobLoading = (loading) => ({
    type: SET_JOB_LOADING,
    payload: loading
});